import { Component, inject, signal } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { finalize } from 'rxjs/operators';
import { UiModule } from '../../../../components/ui.module';
import { tryGetErrorMessage } from '../../../../error.utils';
import { CaseTrackingService } from '../../../../service/case-tracking.service';
import { NotifyService } from '../../../../service/notify.service';
import { CaseIncidentTableEntry } from '../../../../types';
import { TrackReviewActivityDirective } from '../../../directives/track-review-activity.directive';

type CellParams = ICellRendererParams<CaseIncidentTableEntry> & {
  findingsCallback: (item: CaseIncidentTableEntry) => void;
  toggleVisibilityCallback: (item: CaseIncidentTableEntry) => void;
};

@Component({
  selector: 'app-pan-cell-case-tracking-actions',
  imports: [UiModule, MatTooltipModule, RouterModule, TrackReviewActivityDirective],
  templateUrl: './cell-case-tracking-actions.component.html',
  styleUrl: './cell-case-tracking-actions.component.scss',
})
export class CellCaseTrackingActionsComponent implements ICellRendererAngularComp {
  public params!: CellParams;
  private caseTrackingService = inject(CaseTrackingService);
  private notifyService = inject(NotifyService);

  public isHidden = signal<boolean>(false);
  public isTogglingVisibility = signal<boolean>(false);

  agInit(params: CellParams) {
    this.params = params;
    this.isHidden.set(params.data.is_hidden);
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }

  toggleIncidentVisibility() {
    this.isTogglingVisibility.set(true);
    const caseIncident = this.params.data;
    this.caseTrackingService
      .updateIncidentsVisibility(caseIncident.case_id, {
        [caseIncident.review_outcome_id]: !this.isHidden(),
      })
      .pipe(finalize(() => this.isTogglingVisibility.set(false)))
      .subscribe({
        next: () => {
          this.params.data.is_hidden = !this.isHidden();
          this.isHidden.set(!this.isHidden());
          this.params.toggleVisibilityCallback?.(caseIncident);
        },
        error: (err) => {
          this.notifyService.notify(tryGetErrorMessage(err));
        },
      });
  }
}
